/**
 * 체험용 테스트 데이터 — /api/v2/sample-data (매장대표 전용, 자기 매장만).
 *
 * 캠페인 고객에게 계정을 열면 그 매장에 가짜 고객·신청서·재고 등이 «(테스트)» 이름으로 깔린다.
 * 여기서는 얼마나 남아 있는지 보고, 한 번에 지운다. 진본은 server/src/v2/modules/sample-data.
 */
import { authJson } from "./_client";

const API_V2 = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2`;

export interface SampleDataStatus {
  /** 지금 남아 있는 테스트 데이터 건수(표별). 비었으면 띠를 안 띄운다. */
  counts: Record<string, number>;
  total: number;
}

export function fetchSampleDataStatus(): Promise<SampleDataStatus> {
  return authJson<SampleDataStatus>(`${API_V2}/sample-data`);
}

export function clearSampleData(): Promise<{ deleted: number }> {
  return authJson<{ deleted: number }>(`${API_V2}/sample-data`, { method: "DELETE" });
}
